export enum PaymentType {
    Monthly = 8,
    Yearly = 10,
  }
